import { SEARCH_CREATORS } from "../actions/types";

const initialState = {
  creators: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SEARCH_CREATORS:
      return {
        ...state,
        creators: action.payload,
      };
    default:
      return state;
  }
}
